var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9465 3.91052L14.4818 11.4293C14.363 13.3503 14.3036 14.3108 13.8221 15.0014C13.584 15.3428 13.2776 15.631 12.9221 15.8475C12.2031 16.2855 11.2408 16.2855 9.31606 16.2855C7.38887 16.2855 6.42526 16.2855 5.70582 15.8467C5.35013 15.6298 5.04353 15.3411 4.80554 14.9991C4.32419 14.3075 4.26612 13.3456 4.14999 11.4219L3.69653 3.91052",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57153 3.91077H16.0715M12.3633 3.91077L11.8514 2.85456C11.5112 2.15296 11.3411 1.80216 11.0478 1.58337C10.9828 1.53484 10.9139 1.49167 10.8418 1.45429C10.517 1.28577 10.1271 1.28577 9.34741 1.28577C8.54813 1.28577 8.14853 1.28577 7.81829 1.46136C7.74511 1.50027 7.67527 1.54519 7.6095 1.59564C7.31276 1.82329 7.14701 2.18693 6.81549 2.91421L6.36122 3.91077",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44653 12.1606V7.66064",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1965 12.1606V7.66064",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.03d2c66fadefe1c5b0fd5a30eea154f1.svg";
export { ForwardRef as ReactComponent };